import React from "react";

export type TimerContextValue = {
  // start a countdown; if not provided, provider can pick a default
  startCountdown: (endsAtMs?: number) => void;
  updateCountdownEnd: (endsAtMs: number) => void;
  stopCountdown: () => void;
  // subscribe to ticks (sec left). returns an unsubscribe fn
  subscribe: (fn: (secondsLeft: number) => void) => () => void;
};

export const TimerContext = React.createContext<TimerContextValue | null>(null);
